import styled from "styled-components";

const SpocketEducationContainer = styled.div`
  display: flex;
  max-width: 100%;
  padding-top: 100px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 500px);
  background-color: #f4f5f8;

  .CreateAccount__card {
    margin-bottom: 20px;
  }

  .CreateAccount__card:last-of-type {
    margin-bottom: 0;
  }

  /* Vertical line */
  .CreateAccount__card:after {
    content: "";
    left: 30px;
    width: 20px;
    opacity: 0.5;
    height: 20px;
    bottom: -20px;
    display: block;
    position: absolute;
    border: 2px dotted #8144e5;
    border-width: 0 0 0 2px;
  }

  .CreateAccount__card:last-of-type:after {
    display: none;
  }

  @media (max-width: 992px) {
    width: 100%;
    padding: 40px 24px;
  }
`;

const Card = styled.div`
  width: 414px;
  display: flex;
  max-width: 100%;
  padding: 16px 8px;
  border-radius: 8px;
  position: relative;
  align-items: center;
  background-color: #ffffff;
  justify-content: flex-start;
`;

const Icon = styled.img`
  margin-right: 16px;
`;

const Title = styled.div`
  color: #222939;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
`;

const Subtitle = styled.div`
  color: #6f7582;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.25;
`;

const Header = styled.div`
  font-size: 22px;
  font-weight: bold;
  line-height: 1.45;
  color: #222939;
  margin-bottom: 24px;
`;

export { SpocketEducationContainer, Card, Icon, Title, Subtitle, Header };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/CreateAccountStyle.js